import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import { deleteUserApi, activateUserApi } from "../../api/user";
import { deleteRoutesApi } from "../../api/routes";
import { apiBodyMessage } from "../../utils/apiErrorMessage";
import { toast } from "../../utils/toast";

export default function BlockDeleteUserBeartrack({
  block,
  closeModal,
  cerrarModal,
  fetch,
  route,
  user,
  isRoute,
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const methods = useForm({
    mode: "onSubmit",
    defaultValues: block ? route : {},
  });

  // Antes acá se sembraba `pass` con una contraseña por defecto escrita en el
  // código, en el estado del formulario: ni se renderiza un campo de contraseña
  // ni se envía, así que solo dejaba la credencial inventada dando vueltas. El
  // bloqueo/borrado usa activateUserApi/deleteUserApi, no el form.

  const FormDivider = ({ className }) => (
    <div className={`w-full border-t border-gray-300 my-2 ${className}`} />
  );

  const submitValues = useCallback(
    async (values) => {
      setLoading(true);
      try {
        if (block) {
          // await blockUserApi(route._id);
        } else {
          console.log("submitValues_eliminar route:::", route?.id);
        }
        setLoading(false);
        closeModal(false);
        fetch();
      } catch (error) {
        console.error("Error al guardar los cambios:", error);
        setLoading(false);
      }
    },
    [closeModal, block, fetch, route]
  );

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleDelete = useCallback(() => {
    if (!isChecked) return;

    const toastId = toast.loading(t("Procesando..."));
    //console.log("Toast ID created:", toastId);

    if (block) {
      setLoading(true);
      activateUserApi({ userId: user._id, status: false })
        .then((res) => {
          setLoading(false);
          // activateUserApi never rejects: a failed PATCH arrives as { error }.
          if (res?.error) {
            toast.update(toastId, {
              render:
                apiBodyMessage(res.error) || t("Error al bloquear el usuario"),
              type: "error",
              isLoading: false,
              autoClose: 4000,
              position: "bottom-center",
            });
            return;
          }
          //console.log("Calling closeModal for block");
          if (typeof closeModal === "function") closeModal(false);
          if (typeof cerrarModal === "function") cerrarModal(false);
          //console.log("Updating toast for block");
          toast.update(toastId, {
            render: t("Usuario bloqueado exitosamente"),
            type: "success",
            isLoading: false,
            autoClose: 2000,
            position: "bottom-center",
          });
          //console.log("Calling fetch for block");
          if (typeof fetch === "function") fetch();
        })
        .catch((error) => {
          setLoading(false);
          // Defensive: never surface axios transport text ("Network Error").
          toast.update(toastId, {
            render:
              apiBodyMessage(error?.response?.data) ||
              t("Error al bloquear el usuario"),
            type: "error",
            isLoading: false,
            autoClose: 4000,
            position: "bottom-center",
          });
        });
    } else if (isRoute) {
      setLoading(true);
      deleteRoutesApi(route.id)
        .then((response) => {
          //console.log("Delete response:", response);
          setLoading(false);
          //console.log("Calling closeModal for route");
          if (typeof closeModal === "function") closeModal(false);
          if (typeof cerrarModal === "function") cerrarModal(false);
          //console.log("Updating toast for route");
          toast.update(toastId, {
            render: response.message || t("Ruta eliminada exitosamente"),
            type: "success",
            isLoading: false,
            autoClose: 2000,
            position: "bottom-center",
          });
          //console.log("Calling fetch for route");
          if (typeof fetch === "function") fetch();
        })
        .catch((error) => {
          console.error("Delete route error:", error);
          setLoading(false);
          toast.update(toastId, {
            render: error.message || t("Error al eliminar la ruta"),
            type: "error",
            isLoading: false,
            autoClose: 2000,
            position: "bottom-center",
          });
        });
    } else {
      setLoading(true);
      deleteUserApi({ userId: user._id })
        .then(() => {
          setLoading(false);
          //console.log("Calling closeModal for user");
          if (typeof closeModal === "function") closeModal(false);
          if (typeof cerrarModal === "function") cerrarModal(false);
          //console.log("Updating toast for user");
          toast.update(toastId, {
            render: t("Usuario eliminado exitosamente"),
            type: "success",
            isLoading: false,
            autoClose: 2000,
            position: "bottom-center",
          });
          //console.log("Calling fetch for user");
          if (typeof fetch === "function") fetch();
        })
        .catch((error) => {
          setLoading(false);
          toast.update(toastId, {
            render: error.message || t("Error al eliminar el usuario"),
            type: "error",
            isLoading: false,
            autoClose: 2000,
            position: "bottom-center",
          });
        });
    }
  }, [isChecked, fetch, block, isRoute, route, user, closeModal, cerrarModal]);

  return (
    <div>
      <h1 className="text-black font-semibold text-xl mb-0 mt-0">
        {isRoute
          ? t("Eliminar ruta")
          : block
          ? t("Bloquear usuario")
          : t("Eliminar usuario")}
      </h1>
      <FormDivider />
      <Container className="mt-0">
        <Form onSubmit={methods.handleSubmit(submitValues)}>
          <p>
            {isRoute
              ? t("Esta acción no se puede deshacer. Esto eliminará la ruta y todos los clientes que tenía asignada quedarán disponibles para nueva asignación.")
              : t("Esta acción no se puede deshacer. Esto eliminará permanentemente la cuenta de usuario. Todos los datos serán eliminados y no tendrá acceso a la plataforma.")}
          </p>
          <FormDivider className="mb-0" />
          <p className="font-semibold text-[#E11900]">
            {isRoute && route?.deliveryMan?.name
              ? `${t("Repartidor asignado")}: ${route.deliveryMan.name}`
              : t("Repartidor no asignado")}
          </p>
          <FormDivider className="mb-0" />
          <Row className="mt-0">
            <Col xs="12" md="12" xl="12">
              <p>{t("Por favor, selecciona la casilla para confirmar.")}</p>
              <FormGroup check className="mt-3">
                <Input
                  type="checkbox"
                  id="confirmCheckbox"
                  onChange={handleCheckboxChange}
                />
                <Label for="confirmCheckbox" check>
                  {t("Sí, entiendo que es una acción irreversible.")}
                </Label>
              </FormGroup>
            </Col>
            <FormDivider />
          </Row>
          <Row className="mt-4">
            <Col xs="12">
              <Button
                color="orange"
                className="w-100 bg-[#D92D20] text-white hover:bg-[#B42318]"
                type="button"
                disabled={!isChecked || loading}
                onClick={handleDelete}
              >
                {isRoute
                  ? t("Eliminar ruta")
                  : block
                  ? t("Bloquear usuario")
                  : t("Borrar usuario")}
                {loading && <Spinner size="sm" />}
              </Button>
            </Col>
            <Col xs="12" className="mt-2">
              <Button
                color="white"
                className="w-100 text-black border-[#D0D5DD] hover:bg-[#D0D5DD]"
                onClick={() => {
                  if (typeof closeModal === "function") closeModal(false);
                  if (typeof cerrarModal === "function") cerrarModal(false);
                }}
              >
                {t("No, mantener")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </div>
  );
}